import { InjectionToken } from '@angular/core';

export const ANGULARJS_BOOTSTRAP_TIMEOUT = new InjectionToken<number>(
	'timeout till angularJS bootstraps'
);
